/* eslint-disable camelcase */
import { Howl } from 'howler';
import random from 'lodash/random';
import congratsByType from 'utils/congrats-util';

const { VUE_APP_S3_PREFIX } = process.env;
const congratsPrefix = `${VUE_APP_S3_PREFIX}/sites/default/files/voice/congratulatory`;

const getRandomVoiceType = () => (random(1, 2) % 2 === 0 ? 'ma' : 'fa');

const getRandomCongrats = (voiceType = getRandomVoiceType()) => {
  const audioList = congratsByType[voiceType];
  const congrats = audioList[random(audioList.length - 1)];

  return `${congratsPrefix}/${congrats}`;
};

const createAudio = (src, { html5, ...config }) =>
  new Howl({
    src,
    html5,
    ...config
  });

const createAudioAsync = (src, { html5, ...config }) =>
  new Promise(resolve => {
    const howl = new Howl({
      src,
      html5,
      ...config,
      onload: () => resolve(howl),
      onloaderror: () => {
        resolve({
          play: () => {},
          stop: () => {}
        });
      }
    });
  });

const isValidAudioSrc = src =>
  src.endsWith('.mp3') || src.includes('.mp3?') || src.endsWith('.wav') || src.includes('.wav?');

const stopHowl = objWithHowl => {
  if (objWithHowl.howl) {
    if (navigator.userAgent.indexOf('Firefox') !== -1) {
      // Workaround for the Firefox error on Howler stop():
      // "AbortError: The operation was aborted."
      objWithHowl.howl.pause();
      // eslint-disable-next-line no-param-reassign
      objWithHowl.howl = null;
    } else {
      objWithHowl.howl.stop();
    }
  }
};

export {
  getRandomVoiceType,
  getRandomCongrats,
  createAudio,
  createAudioAsync,
  isValidAudioSrc,
  stopHowl,
  Howl
};
